import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import CustomPagination from "../../Utils/CustomPagination";
import { useSelector } from "react-redux";
import { AddCircle, Edit, Edit2, Eye, ProfileAdd, Trash } from "iconsax-react";

function List(props) {
  const [Billing, SetBilling] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: (
        <div>
          Company Name <br />
        </div>
      ),
      selector: (row) => row.company_name,
    },
    {
      name: "GST Number",
      selector: (row) => row.gst,
    },
    {
      name: "Address",
      selector: (row) => row.address,
      wrap: true,
      width: "300px",
    },
    {
      name: "State",
      selector: (row) => row.state_name,
    },

    {
      name: "District",
      selector: (row) => row.district_name,
    },
    {
      name: "City",
      selector: (row) => row.city_name,
    },
    {
      name: "Status",
      selector: (row) => (row.status == "1" ? "Active" : "InActive"),
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          {utils.hasPermission(
            primaryMenuRes,
            "Billing Location",
            "billing_location.edit"
          ) && (
            <RB.Button
              className="btn-flat"
              title="Edit"
              onClick={handelEdit(row)}
            >
              <Edit2 />
            </RB.Button>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Billing Location",
            "billing_location.delete"
          ) && (
            <RB.Button
              className="btn-flat ms-1"
              title="Delete"
              onClick={showDelete(row)}
            >
              <Trash />
            </RB.Button>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    getBilling();
  }, [page, filterText]);

  const getBilling = () => {
    utils
      .callAPI(
        "get",
        `/billinglocation/list?page=${page}&per_page=${countPerPage}&company_name=${filterText}&status`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          SetBilling(res);
        } else {
          SetBilling([]);
        }
      })
      .catch((err) => {
        SetBilling([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "add",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/billinglocation/delete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getBilling();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(
              primaryMenuRes,
              "Billing Location",
              "billing_location.create"
            ) && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )}
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            "Billing Location",
            "billing_location.view"
          ) && (
            <DataTable
              columns={columns}
              data={Billing.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={Billing.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              paginationComponent={() => (
                <CustomPagination
                  currentPage={page}
                  totalRows={Billing.total}
                  rowsPerPage={countPerPage}
                  onPageChange={handlePageChange}
                />
              )}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              subHeader
              subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
